// file created at 2019. 12. 26.
// Auto-generated files App.ts

import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  private mounted() {
    //
  }
}
